import React from "react";
import { Box, Heading, Flex, useColorMode, Text, Switch } from "@chakra-ui/core";
import { withRouter } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { userAtom } from '../global/gloablState'

const NavBar = ({ history }) => {
    const [user, setUser] = useRecoilState(userAtom)
    const [show, setShow] = React.useState(false);
    const handleToggle = () => setShow(!show);
    const { colorMode, toggleColorMode } = useColorMode();

    const logout = () => {
        localStorage.removeItem('user')
        setUser(null);
        history.push('/')
    }
    return (
        <Flex
            as="nav"
            align="center"
            justify="space-between"
            wrap="wrap"
            padding="1.5rem"
            bg={colorMode === "dark" ? "gray.900" : "green.300"}
            color={colorMode === "dark" ? "white" : "black"}
        >
            <Flex align="center" mr={5}>
                <Heading as="h1" size="lg" letterSpacing={"-.1rem"}>
                    <Text onClick={() => history.push('/')} color={colorMode === "dark" ? "green.400" : "brand.700"}>Salyd</Text>
                </Heading>
            </Flex>

            <Box display={{ sm: "block" ,base: "block", md: "none" }} borderWidth="1px" onClick={handleToggle}>
                <svg
                    fill={colorMode==="light"?"gray.900":"white"}
                    width="12px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <title>Menu</title>
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>
            </Box>

            <Box
                display={{ base: show ? "block" : "none", md: "flex" }}
                width={{ base: "full", md: "auto" }}
                alignItems="center"
                flexGrow={1}
            >
                {
                    user
                        ?
                        <React.Fragment>
                            <Text onClick={() => history.push('/dashboard')} mt={{ base: 4, md: 0 }} mr={6} display="block">
                                Dashboard
                            </Text>
                            <Text onClick={() => history.push('/menu')} mt={{ base: 4, md: 0 }} mr={6} display="block">
                                Edit Menu
                            </Text>
                            <Text onClick={logout} mt={{ base: 4, md: 0 }} mr={6} display="block">
                                Logout
                            </Text>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Text onClick={() => history.push('/signup')} mt={{ base: 4, md: 0 }} mr={6} display="block">
                                Sign Up
                            </Text>
                            <Text onClick={() => history.push('/dashboard')} mt={{ base: 4, md: 0 }} mr={6} display="block">
                                Login
                            </Text>
                        </React.Fragment>
                }
            </Box>

            <Box
                display={{ base: show ? "block" : "none", md: "block" }}
                mt={{ base: 4, md: 0 }}
            >
                <Switch size="lg" color="green" isChecked={colorMode ==="light"} onChange={toggleColorMode} />
            </Box>
        </Flex>
    );
};

export default withRouter(NavBar);
